export default "__VITE_ASSET__DGHbdWVN__"